<template>
  <div class="lan-port-status-card">
    <div class="lan-port-status-card__header">
      <span>
        <div class="lan-port-status-card__header--indicator indicator"></div>
        <div class="lan-port-status-card__header--text">{{ header }}</div>
      </span>
      <span class="edit-btn mdi mdi-border-color" @click.prevent="openModal">
      </span>
    </div>
    <div class="lan-port-status-card__container">
      <div class="lan-port-status-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.LAN.interface") }}
        </div>
        <div class="text">
          {{ header ? header : "N/A" }}
        </div>
      </div>
      <div class="lan-port-status-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.LAN.ip_address") }}
        </div>
        <div class="text">
          {{ this.dataLan.local_ip ? this.dataLan.local_ip : "N/A" }}
        </div>
      </div>
      <div class="lan-port-status-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.LAN.mask") }}
        </div>
        <div class="text">
          {{ this.dataLan.mask ? this.dataLan.mask : "N/A" }}
        </div>
      </div>
      <div class="lan-port-status-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.LAN.wan_interfaces") }}
        </div>
        <div class="text">{{this.dataLan.lan_wan ? this.dataLan.lan_wan.toString() : "N/A"}}
          <!-- {{
            this.selectedLanWanInterfaces
              ? this.selectedLanWanInterfaces.toString()
              : "N/A"
          }} -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanModal from "./LanModal.vue";
import ipSubnetCalculator from "ip-subnet-calculator";

export default {
  name: "LAN",
  components: {
    LanModal,
    ipSubnetCalculator,
  },
  props: {
    dataLan: Object,
    header: String,
    optionsWAN: Array,
    listWanTunnels: Array,
    //selectedLanWanInterfaces: Array,
    optionsPorts: Array,
    dnsmasq: Object,
  },
  data() {
    return {
      lanData: [],
    };
  },
  computed: {},
  methods: {
    openModal(val) {
      var t = this.$createElement(LanModal, {
        props: {
          dataLan: this.dataLan,
          optionsWAN: this.optionsWAN,
          header: this.header,
          listWanTunnels: this.listWanTunnels,
          //selectedLanWanInterfaces: this.selectedLanWanInterfaces,
          optionsPorts: this.optionsPorts,
        },
        on: {
          close: () => {
            this.$modal.hide("dynamic-modal");
          },
          update: (data) => {
            this.$emit("update", data);
          },
          delete: (val) => {
            this.$emit("delete", val);
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
        temp,
        {},
        {
          height: "auto",
          adaptive: true,
          clickToClose: true,
          scrollable: true,
          name: "dynamic-modal",
        }
      );
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.lan-port-status-card {
  color: #fff;
  background: #f4f3ef;
  border-radius: 6px;
  max-width: 380px;
  width: 100%;
  margin-right: 24px;
  margin-bottom: 10px;
  box-shadow: 0 2px 2px #ccc5b980;
  border: 1px solid #ccc;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 19px;
    //border-bottom: 1px solid #3a3c40;
    border-bottom: 1px solid #cecfd1;
    background: #e2ecdc;
    span {
      display: flex;
      align-items: center;
    }
    &--indicator {
      margin-right: 10px;
    }

    &--text {
      //color: #c3c7ca;
      color: black;
      font-size: 13px;
    }
    &--more {
      text-transform: uppercase;
      color: #c3c7ca;
      font-size: 11px;
    }
    .edit-btn {
      font-size: 22px;
      cursor: pointer;
      //color: #54896c;
      color: black;
    }
  }
  &__container {
    padding: 5px 19px;

    &--row {
      margin: 14px 0;
      display: flex;
      align-items: center;
      .title {
        max-width: 150px;
        font-size: 13px;
        width: 100%;
        margin-right: 10px;
        text-align: left;
        color: black;
      }
      .text {
        display: flex;
        font-size: 13px;
        //color: #c3c7ca;
        color: black;
        align-items: center;
        .db-indicator {
          margin-right: 10px;
          padding: 4px 10px;
          border-radius: 2px;
          color: white;
        }
        .changes {
          color: #c3c7ca;
          font-size: 13px;
          border-bottom: 1px solid #c3c7ca;
          border-bottom-style: dashed;
        }
      }
    }
  }
}
</style>
